import React, { useLocation } from "wouter";
import { months, years } from "../config";
import { uploadBustePagaMassive, uploadCuMassive } from "../services/api";
import UploadForm from "./upload_form";
import { useState } from "react";
// import { useNavigate } from 'wouter';

export default function CardCaricaCu(props) {
  // const navigate = useNavigate()

  const [location, setLocation] = useLocation();

  return (
    <div className = "overflow-hidden rounded-lg bg-white mb-10" >
      <div className="p-2">
        <h2 className="text-base font-medium text-gray-900" id="recent-hires-title">
          Carica Certificazioni Uniche Massive
        </h2>
        <div className="mt-6 flow-root">
          <UploadForm
            enableUpload={true}
            message={{ success: <a href="#" onClick={() => { props.setClose(false); setLocation('/cu');}}>Per confermare i documenti clicca qui</a>}}
            fields={
              [
                { name: 'year', label: 'Anno', type: 'select', options: years },
                { name: 'reference_year', label: 'Anno di Riferimento', type: 'select', options: years },
                {
                  name: 'notify_employee', label: 'Notifica i dipendenti via email', type: 'checkbox', options: [
                    { label: 'Si', value: true }
                  ]
                },
                { type: 'hidden', name: 'anagrafica_create_missing', value: 'true' },
                { type: 'hidden', name: 'typology', value: 'bp' }
              ]
            }
            formType="CUMassive"
            submitLabel="Carica"
            submitAction={uploadCuMassive}
          />
        </div>
      </div>
    </div>
  )

}